// Profile pictures: GET /v1/users/{user}/avatar/{avatar} needs the bearer token, so they are
// fetched and shown as object URLs. The server decrypts them; a new picture has a new id.

import type { Session } from "../auth/session.ts";

const cache = new Map<string, Promise<string | undefined>>();

export function avatarUrl(session: Session, user: string, avatar: string | null | undefined): Promise<string | undefined> {
  if (!avatar) return Promise.resolve(undefined);
  const key = `${user}/${avatar}`;
  let pending = cache.get(key);
  if (!pending) {
    pending = session
      .token()
      .then((token) => fetch(`/v1/users/${user}/avatar/${avatar}`, { headers: { authorization: `Bearer ${token}` } }))
      .then(async (r) => (r.ok ? URL.createObjectURL(await r.blob()) : undefined))
      .catch(() => undefined);
    cache.set(key, pending);
  }
  return pending;
}

export function clearAvatars() {
  for (const pending of cache.values()) void pending.then((u) => u && URL.revokeObjectURL(u));
  cache.clear();
}
